import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { authFirebase } from "../../../config/firebase";
import * as auth from "./redux/AuthRedux";

export function Logout() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(auth.actions.logout());
    signOut(authFirebase).finally(() => {
      document.location.reload();
    });
  }, [dispatch]);

  return <Navigate to="/auth/login" replace />;
}
